import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import { useSearchParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiSelect-root": {
			backgroundColor: "#FFF",
		},
	},
	formControl: {
		width: "100%",
	},
}));

type Props = {};

export const StatusFilter = ({}: Props) => {
	const classes = useStyles();
	const {
		state: { statusCodes },
	} = useAssetDetailsContext();
	const [searchParams, setSearchParams] = useSearchParams();
	const status = searchParams.get("status") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("status", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<div className={classes.root}>
			<FormControl
				variant="outlined"
				margin="dense"
				className={classes.formControl}
			>
				<InputLabel id="status-select-label">Status</InputLabel>
				<Select
					labelId="status-select-label"
					id="status-select"
					value={status}
					onChange={handleFilter}
					label="Status"
				>
					{statusCodes.map((status) => {
						return (
							<MenuItem
								style={{ paddingBottom: 0 }}
								key={`logId-${status.id}`}
								value={status.id}
							>
								{status.description}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
};
